import { gql } from 'graphql-tag'
import { seoFragment } from '../fragments/seo.js'

export const getNewsItem = gql`
  ${seoFragment}
  query getNewsItem($slug: [String], $site: [String]) {
    newsEntries(slug: $slug, site: $site) {
      ... on news_Entry {
        id
        localized {
          slug
          language
        }
        seo {
          ...SeoFragment
        }
        title
        dataPubblicazione
        sezioneContenutoPagina {
          ... on testo_Entry {
            text
          }
          ... on immagine_Entry {
            custom: immagine @transform(format: "webp", width: 1800) {
              id
              url
              width
              height
              title
            }
          }
          ... on immagineTradotta_Entry {
            custom: immagineTradotta @transform(format: "webp", width: 1800) {
              id
              url
              width
              height
              title
            }
          }
        }
        notizieCorrelate {
          ... on news_Entry {
            slug
            title
            introNews
            sezioneContenutoPagina {
              ... on immagine_Entry {
                custom: immagine @transform(format: "webp", width: 740) {
                  id
                  url
                  width
                  height
                  title
                }
              }
              ... on immagineTradotta_Entry {
                custom: immagineTradotta
                  @transform(format: "webp", width: 1800) {
                  id
                  url
                  width
                  height
                  title
                }
              }
            }
          }
        }
      }
    }
  }
`
